export default __webpack_public_path__ + "static/media/spideyScene.05709591.png";